import { render, staticRenderFns } from "./not-available.vue?vue&type=template&id=4c94ea97"
import script from "./not-available.vue?vue&type=script&lang=js"
export * from "./not-available.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/errors/not-available.vue
// module id = null
// module chunks = 